export class HrPayEngineResultKey {
    private static readonly keyPrefix = 'hrPayEngineResult';
    public static hrmPerPeopleUuid = `${HrPayEngineResultKey.keyPrefix}.hrmPerPeopleUuid`;
    public static isSuccessful = `${HrPayEngineResultKey.keyPrefix}.isSuccessful`;
    public static pageHeader = `${HrPayEngineResultKey.keyPrefix}.pageHeader`;
    public static section = `${HrPayEngineResultKey.keyPrefix}.section`;
    public static wageType = `${HrPayEngineResultKey.keyPrefix}.wageType`;
    public static amount = `${HrPayEngineResultKey.keyPrefix}.amount`;
    public static number = `${HrPayEngineResultKey.keyPrefix}.number`;
    public static rate = `${HrPayEngineResultKey.keyPrefix}.rate`;
    public static calculatedAmount = `${HrPayEngineResultKey.keyPrefix}.calculatedAmount`;
    public static netCalculatedAmount = `${HrPayEngineResultKey.keyPrefix}.netCalculatedAmount`;
    public static day = `${HrPayEngineResultKey.keyPrefix}.day`;
}
